import React, { Fragment, useState, useEffect } from 'react'
import Cookie from 'js-cookie'

import SignupSuccessModal from 'desktop/components/modals/signup_success_modal'
import NewUserModal from 'desktop/components/modals/new_user_modal'
import { EVERLANE_USER } from 'cookies.yml'
import Hub from 'base/hub'

function FollowUpModal({ emailEnteredEvent, siteLocation }) {
  const [showSignUpSuccessModal, setShowSignUpSuccessModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [email, setEmail] = useState()

  useEffect(() => {
    Hub.sub(emailEnteredEvent, (_event, eventData) => {
      setEmail(eventData.email)

      if (eventData.shouldAskForPassword) {
        setShowModal(true)
      } else {
        setShowSignUpSuccessModal(true)
      }
    })
  }, [email, emailEnteredEvent, siteLocation])

  return (
    <Fragment>
      {showSignUpSuccessModal && (
        <SignupSuccessModal onRequestClose={() => setShowSignUpSuccessModal(false)} />
      )}

      {showModal && (
        <NewUserModal
          skipEmailEntry
          email={email}
          onRequestClose={() => setShowModal(false)}
          siteLocation={siteLocation}
          hasRepeatUserCookie={!!Cookie.get(EVERLANE_USER)}
          onSignUpSuccess={() => setShowSignUpSuccessModal(true)}
        />
      )}
    </Fragment>
  )
}

export default FollowUpModal
